import './Training.scss';
import Component from './Training';
export default Component;